var listLangAvailable = [
    'ca-ES',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'en-GB',
    'en-US',
    'es-ES',
    'fi-FI',
    'fr-FR',
    'ja-JP',
    'ko-KR',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'zh-CN',
    'it-IT'
]

function checkDiff(startTarget, endTarget, diff, dateType, currentTarget) {
    var dayOne = moment(startTarget.val());
    var dayTwo = moment(endTarget.val());
    var diffTime = 0;
    switch (dateType) {
        case 'minutes':
            diffTime = diff * 60 * 1000;
            break;
        case 'hours':
            diffTime = diff * 60 * 60 * 1000;
            break;
        case 'days':
            diffTime = diff * 24 * 60 * 60 * 1000;
            break;
        default:
            diffTime = 0
    }
    if((dayOne.diff(dayTwo) > 0 || Math.abs(dayOne.diff(dayTwo)) < diffTime) && currentTarget.attr('id') === startTarget.attr('id')){
        endTarget.val(dayOne.add(diff, dateType).format('YYYY-MM-DD'));
        endTarget.trigger('update');
    }
    if(dayOne.diff(dayTwo) > 0 && currentTarget.attr('id') === endTarget.attr('id')){
        startTarget.val(dayTwo.format('YYYY-MM-DD'));
        startTarget.trigger('update');
    }
};

function initDatePicker(el, zIndex) {
    var $date = $(el);
    var currentZindex = (zIndex) ? zIndex : 1;
    var $existingClone = $('#'+$date.attr('id') + '_clone');
    if($existingClone.length){
        $existingClone.parent().remove();
    }
    var $cloneDate = $('<div/>').append($date.clone());
    var $cloneDateInput = $cloneDate.find('input');
    var $periodStart = $("#period_start, #car_rent_periodStart");
    var $periodEnd = $("#period_end, #car_rent_periodEnd");
    var currentLang = 'fr-FR';

    listLangAvailable.forEach(function (elem) {
        if(elem.match(Wlz.Settings.Header.locale) !== null){
            currentLang = elem;
        }
    });

    var param = {
        zIndex: currentZindex,
        language: currentLang
    };

    $date.after($cloneDate);
    $cloneDateInput
        .removeAttr('name')
        .attr('id' ,$date.attr('id') + '_clone')
        .attr('type','text')
        .prop('autocomplete','off')
        .prop('placeholder','jj/mm/aaaa');

    $cloneDate.addClass('wrapper-calendar icon-calendar');

    if($date.val() && moment($date.val()).format('DD/MM/YYYY') !== 'Invalid date'){
        $cloneDateInput.val(moment($date.val()).format('DD/MM/YYYY'));
    }
    $cloneDateInput.css('display', '');
    $date.css('display', 'none');


    param.template = '<div class="datepicker-container">'+
    '        <div class="datepicker-panel" data-view="years picker">'+
    '            <ul class="top-menu">'+
    '              <li data-view="years prev" class="icon-left-dir-1"></li>'+
    '              <li data-view="years current"></li>'+
    '              <li data-view="years next" class="icon-right-dir-1"></li>'+
    '            </ul>'+
    '            <ul data-view="years"></ul>'+
    '        </div>'+
    '        <div class="datepicker-panel" data-view="months picker">'+
    '            <ul class="top-menu">'+
    '              <li data-view="year prev" class="icon-left-dir-1"></li>'+
    '              <li data-view="year current"></li>'+
    '              <li data-view="year next" class="icon-right-dir-1"></li>'+
    '            </ul>'+
    '        <ul data-view="months"></ul>'+
    '        </div>'+
    '        <div class="datepicker-panel" data-view="days picker">'+
    '            <ul class="top-menu">'+
    '              <li data-view="month prev" class="icon-left-dir-1"></li>'+
    '              <li data-view="month current"></li>'+
    '              <li data-view="month next" class="icon-right-dir-1"></li>'+
    '            </ul>'+
    '        <ul class="week" data-view="week"></ul>'+
    '        <ul data-view="days"></ul>'+
    '        </div>'+
    '    </div>';


    if($date.is($periodStart) || $date.is($periodEnd)){
        param.startDate = moment();
    }

    $(function() {
        $cloneDateInput.datepicker(param);
    });

    $cloneDateInput.parent().on('click',function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.wrapper-calendar').find('input').datepicker('hide');
        $cloneDateInput.trigger('focus').datepicker('show');
    });

    $cloneDateInput.on('change', function (e) {
        $periodStart = $("#period_start, #car_rent_periodStart");
        $periodEnd = $("#period_end, #car_rent_periodEnd");
        var value = $cloneDateInput.val();
        value = value.split(/[\/\\\-\.]/).join('-');
        var selectDate = moment(value,["DD-MM-YYYY"]);
        if(!selectDate.isValid()){
            $date.val('');
            $cloneDate.addClass('error');
        } else {
            $date.val(selectDate.format('YYYY-MM-DD'));
            $cloneDate.removeClass('error');
        }
        if($periodStart.length && $periodEnd.length){
            if($periodStart.is('#period_start') && $periodEnd.is('#period_end')) {
                checkDiff($periodStart, $periodEnd, 2, 'days', $date);
            }else {
                checkDiff($periodStart, $periodEnd, 0, '', $date);
            }
        }
        $date.trigger('change');
    });

    $date.on('update', function(e) {
        $periodStart = $("#period_start, #car_rent_periodStart");
        $periodEnd = $("#period_end, #car_rent_periodEnd");
        if(!$(e.currentTarget).val()) {return false;}
        $cloneDateInput.prop('value', moment($(e.currentTarget).val()).format('DD/MM/YYYY'));
        $cloneDateInput.datepicker('update');
    });
}

$('input[type="date"]').each(function(i, el){
    initDatePicker(el);
});

$('input[type="search"]').on('keypress', function (e) {
    if(e.keyCode === 13){
        $(e.currentTarget).closest('form').submit();
    }
})
